const skills = {

    sub: "our skills",
    heading: "Exceptional Architecture and Design.",
    content: "At Lumina, we are dedicated to providing top-notch architecture and interior design solutions that transform spaces into functional and aesthetically pleasing environments.",
    points: [
        {
            id: 1,
            title: "Innovative Designs",
            progress: 85,
        },
        {
            id: 2,
            title: "Client Satisfaction",
            progress: 95,
        },
        {
            id: 3,
            title: "Project Completion",
            progress: 98,
        },
        {
            id: 4,
            title: "Attention to Detail",
            progress: 90,
        },
    ],
};

export default skills;